import FormError from '~/client/shared/form/FormError';
import FormInput from '~/client/shared/form/FormInput';
import FormReCAPTCHA from '~/client/shared/form/FormReCAPTCHA';
import Stack from '~/client/shared/Stack';
import CreateAccountLink from './CreateAccountLink';
import useEnterPasswordStep from './useEnterPasswordStep';
import ForgotPasswordLink from '../../../Shared/ForgotPasswordLink';
import InvalidCredentialsBox from '../../InvalidCredentialsBox';
import SubmitButtonFormItem from '../shared/SubmitButtonFormItem';

type Props = {
  isPopover?: boolean;
};

const EnterPasswordStep = ({ isPopover }: Props) => {
  const {
    showInvalidCredentials,
    setShowInvalidCredentials,
    required,
    control,
    errors,
    captchaRequired,
    recaptchaRef,
    handleCreateAccount,
    loading,
    handleSubmit,
    isSubmitDisabled,
  } = useEnterPasswordStep({ isPopover });

  const handleShowInvalidCredentials = () => {
    setShowInvalidCredentials(false);
  };

  return (
    <form>
      <Stack>
        {showInvalidCredentials && (
          <InvalidCredentialsBox handleClose={handleShowInvalidCredentials} />
        )}
        <FormInput
          {...required('password')}
          type="password"
          placeholder="profile.password_field"
          autoCapitalize="off"
          error={errors?.password?.message}
          inputSize="xlarge"
        />
        {captchaRequired && (
          <FormReCAPTCHA
            recaptchaRef={recaptchaRef}
            name="captcha"
            control={control}
            error={errors?.captcha?.message}
            rules={{
              required: captchaRequired && 'errors.input.required',
            }}
          />
        )}
        <SubmitButtonFormItem
          loading={loading}
          isSubmitDisabled={isSubmitDisabled}
          handleSubmit={handleSubmit}
          translateId="profile.login"
          dataTestId="register-submit"
        />
        <ForgotPasswordLink
          isUnderline
          color="bulma.100"
          size={12}
          fontWeight={600}
        />
        <CreateAccountLink handleCreateAccount={handleCreateAccount} />
        {errors?.global?.message && (
          <FormError
            message={errors.global.message}
            data-testid={errors?.global?.message}
          />
        )}
      </Stack>
    </form>
  );
};

export default EnterPasswordStep;
